import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'lubbu-header',
  templateUrl: 'lubbu-header.html'
})
export class LubbuHeaderComponent {
  @Input() public title: string;

  constructor(private location: Location) {}

  /**
   * Cancel action
   *
   * @memberof LubbuHeaderComponent
   */
  cancel(): void {
    this.location.back();
  }
}



// WEBPACK FOOTER //
// ./src/components/lubbu-header/lubbu-header.ts